import {customAlphabet} from 'nanoid';
import config from "@/config";
import storage from "@/utils/storage";

/**
 * TODO rename to obtainClientAuthToken() as clientId is just a part of the obtained token.
 * @param withResetId
 * @param withResetTab
 * @returns {string}
 */
export function obtainClientId(withResetId = false, withResetTab = false) {
	let clientId = storage.getString(config.STORAGE_CLIENT_ID_TOKEN);
	if (withResetId || !clientId || clientId?.length !== config.CLIENT_ID_LENGTH) {
		const nanoid = customAlphabet(config.CLIENT_ID_ALPHABET, config.CLIENT_ID_LENGTH);
		clientId = nanoid();
		storage.set(config.STORAGE_CLIENT_ID_TOKEN, clientId);
	}

	let tabId = storage.getSessionString(config.STORAGE_TAB_ID_TOKEN);
	if (withResetTab || !tabId || tabId?.length !== config.CLIENT_ID_LENGTH) {
		const nanoid = customAlphabet(config.CLIENT_ID_ALPHABET, config.CLIENT_ID_LENGTH);
		tabId = nanoid();
		storage.setSession(config.STORAGE_TAB_ID_TOKEN, tabId);
	}

	return clientId + "_" + tabId;
}

/**
 * Id вкладки из клиентского токена "<clientId>_<tabId>" (в отличие от clientId, не секрет).
 * @param clientAuth токен, см. obtainClientId()
 * @returns {string|undefined}
 */
export function tabIdFromClientAuth(clientAuth) {
	return clientAuth?.length === config.CLIENT_ID_LENGTH * 2 + 1 ? clientAuth.slice(-config.CLIENT_ID_LENGTH) : undefined;
}

/**
 * Id приглашения из письма. Хранится до успешной авторизации - OAuth-редирект и переход
 * по ссылке из письма теряют query, поэтому кладём в localStorage.
 * @returns {string|undefined}
 */
export function obtainInvitationId() {
	return storage.getString(config.STORAGE_INVITATION_ID) || undefined;
}

export function setInvitationId(invitationId) {
	storage.set(config.STORAGE_INVITATION_ID, invitationId);
}

export function clearInvitationId() {
	storage.clear(config.STORAGE_INVITATION_ID);
}

export function obtainClientIMKey() {
	return storage.getString(config.STORAGE_CLIENT_IM_KEY);
}

export function setClientAuthIMKey(imKey) {
	storage.set(config.STORAGE_CLIENT_IM_KEY, imKey);
	//storage.setSession(config.STORAGE_CLIENT_IM_KEY, imKey);
}

export function clientIdFromClientAuth(clientAuth) {
	return clientAuth?.replace(/^(.{16})([._].{16})?$/, "$1");
}

export function obtainWorkspaceAuth() {
	return storage.getString(config.STORAGE_WORKSPACE_AUTH);
}